import { Instant } from "@/temporal"
import { enumSchema, objectSchema } from "vue-utils"
import { extend, Identifiable, Nullable } from "../BaseEntity"
import { ExportFormType, ExportStageType } from "../ExportTypes"

export interface MarriageClaimExport extends Identifiable {
	FormType: ExportFormType
	StageType: Nullable<ExportStageType>
	ExportDate: Instant
}

export const MarriageClaimExport = objectSchema<MarriageClaimExport>({
	...extend(Identifiable),
	FormType: enumSchema(ExportFormType),
	StageType: Nullable(enumSchema(ExportStageType)),
	ExportDate: Instant.Schema,
})
